import {
  createPlugin,
  createApiRef,
} from '@backstage/core-plugin-api';
import {
  CreateGoldenPathRequest,
  GoldenPathDetail,
  GoldenPathForTemplate,
  GoldenPathListItem,
  GoldenPathPage,
  GuidelinesAiContext,
  GuidelinesAiResponse,
  UpdateGoldenPathRequest,
  UpdateTemplateLinksRequest,
  UpsertGoldenPathPageRequest,
} from '@internal/plugin-golden-paths-common';
import { rootRouteRef } from './routes';

export interface GoldenPathsApi {
  listPaths(): Promise<GoldenPathListItem[]>;
  listPathsForTemplate(
    templateEntityRef: string,
  ): Promise<GoldenPathForTemplate[]>;
  getPath(slug: string): Promise<GoldenPathDetail>;
  createPath(input: CreateGoldenPathRequest): Promise<GoldenPathDetail>;
  updatePath(
    slug: string,
    input: UpdateGoldenPathRequest,
  ): Promise<GoldenPathDetail>;
  archivePath(slug: string): Promise<void>;
  upsertPage(
    slug: string,
    pageSlug: string,
    input: UpsertGoldenPathPageRequest,
  ): Promise<GoldenPathPage>;
  updateTemplateLinks(
    slug: string,
    input: UpdateTemplateLinksRequest,
  ): Promise<string[]>;
  improveGuidelines(input: {
    guidelines: string;
    context?: GuidelinesAiContext;
  }): Promise<GuidelinesAiResponse>;
  generateGuidelines(input: {
    prompt: string;
    context?: GuidelinesAiContext;
  }): Promise<GuidelinesAiResponse>;
  chatGuidelines(input: {
    message: string;
    guidelines?: string;
    context?: GuidelinesAiContext;
  }): Promise<GuidelinesAiResponse>;
}

export const goldenPathsApiRef = createApiRef<GoldenPathsApi>({
  id: 'plugin.golden-paths.service',
});

export const goldenPathsPlugin = createPlugin({
  id: 'golden-paths',
  routes: {
    root: rootRouteRef,
  },
  apis: [],
});
